module.exports = __webpack_public_path__ + "static/img/DSC_1563.89364242.jpg";